/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Crosspostingoverviewdescription2Inputs */

const en_crosspostingoverviewdescription2 = /** @type {(inputs: Crosspostingoverviewdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Track the status of your published and pending posts.`)
};

const de_crosspostingoverviewdescription2 = /** @type {(inputs: Crosspostingoverviewdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verfolge den Status deiner veröffentlichten und ausstehenden Beiträge.`)
};

/**
* | output |
* | --- |
* | "Track the status of your published and pending posts." |
*
* @param {Crosspostingoverviewdescription2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const crosspostingoverviewdescription2 = /** @type {((inputs?: Crosspostingoverviewdescription2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Crosspostingoverviewdescription2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_crosspostingoverviewdescription2(inputs)
	return de_crosspostingoverviewdescription2(inputs)
});
export { crosspostingoverviewdescription2 as "crosspostingOverviewDescription" }